import React from 'react'
import RepeatIcon from '@mui/icons-material/Repeat';
import Pill from '../../shared/helpers/Pill';
import { formatDateReadable } from '../../utilities/helpers';
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton";
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import PendingTableEmployeeRowTradeDrawer from './PendingTableEmployeeRowTradeDrawer';

function PendingTableEmployeeRowTrade(props) {

  const tradeReceiver = props.myUserId === props.employee_pickup.id

  let cardStatus = ""
  if (props.rescinded_by === "employee-drop" && tradeReceiver) {
    // cardStatus = "rescinded (them)"
    cardStatus = "rescinded"
  } else if (props.rescinded_by === "employee-drop") {
    cardStatus = "rescinded"
  } else if (props.acting_manager_response === "approved") {
    cardStatus = "approved"
  } else if (props.acting_manager_response === "pending" && props.employee_pickup_response === "denied" && tradeReceiver) {
    // cardStatus = "denied (you)"
    cardStatus = "denied"
  } else if (props.acting_manager_response === "pending" && props.employee_pickup_response === "denied") {
    // cardStatus = "denied (them)"
    cardStatus = "denied"
  } else if (props.acting_manager_response === "pending") {
    cardStatus = "pending"
  } else if (props.acting_manager_response === "denied") {
    cardStatus = "denied"
  } else {
    cardStatus = ""
  }

  const [isDrawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  return (
    <>
      <tr className="hover:bg-slate-50 cursor-pointer transition-colors" onClick={toggleDrawer(true)}>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm pl-6">
          <div className="flex items-center space-x-2">
            <div className="w-9 h-9 bg-slate-200 rounded-full flex items-center justify-center">
              <SwapHorizIcon sx={{ fontSize: 18, color: "#475569" }} />
            </div>
            <p className="font-semibold text-slate-900 text-sm">{tradeReceiver ? "Incoming" : "Outgoing"} Trade Request</p>
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm pl-6">
          <div>
            <p className="font-semibold text-slate-900 text-sm">{formatDateReadable(props.senderDate)}</p>
            <p className="text-slate-500 text-xs mt-0.5">{props.shift_drop_info.shift}</p>
            <p className="text-slate-500 text-xs">{props.shift_drop_info.station ? props.shift_drop_info.station?.name : props.shift_drop_info.role ? props.shift_drop_info.role : props.shift_drop_info.roleType}</p>
            <p className="text-violet-600 text-xs mt-0.5">
              {!tradeReceiver
                ? "You are trading away"
                : `${props.employee_drop.first_name} ${props.employee_drop.last_name} is trading away`}
            </p>
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
          <div className="text-slate-400">
            <RepeatIcon sx={{ fontSize: 18 }} />
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
          <div>
            <p className="font-semibold text-slate-900 text-sm">{formatDateReadable(props.receiverDate)}</p>
            <p className="text-slate-500 text-xs mt-0.5">{props.shift_pickup_info.shift}</p>
            <p className="text-slate-500 text-xs">{props.shift_pickup_info.station ? props.shift_pickup_info.station?.name : props.shift_pickup_info.role ? props.shift_pickup_info.role : props.shift_pickup_info.roleType}</p>
            <p className="text-violet-600 text-xs mt-0.5">
              {tradeReceiver
                ? "You are trading away"
                : `${props.employee_pickup.first_name} ${props.employee_pickup.last_name} is trading away`}
            </p>
          </div>
        </td>
        <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
        </td>
        <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
          <div className="flex items-center justify-end gap-x-3">
            <Pill status={cardStatus} />
            <div className="w-10 flex items-center justify-center">
              {cardStatus !== "pending" ?
                <Tooltip title="Archive">
                  <IconButton
                    className="text-slate-400"
                    sx={{ backgroundColor: "#f8fafc", "&:hover": { backgroundColor: "#f1f5f9" } }}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.archive_shift_change_request(props.uuid);
                    }}
                  >
                    <ArchiveOutlinedIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip> : null
              }
            </div>
          </div>
        </td>
      </tr>
      <PendingTableEmployeeRowTradeDrawer
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
        tradeInfo={props}
        tradeReceiver={tradeReceiver}
        cardStatus={cardStatus}
        rescind_trade_shift={props.rescind_trade_shift}
        respond_to_trade_request={props.respond_to_trade_request}
        myId={props.myId}
      />
    </>
  )
}

export default PendingTableEmployeeRowTrade
